import BucketApiRequest from "./BucketApiRequest";
import { GET_ID_TYPES } from "../ApiUrls";

export default class GetIdTypeList extends BucketApiRequest {
  getUrl = () => {
    return GET_ID_TYPES;
  };
}
